<template>
<div class="d-flex flex-column align-center justify-center fraction fraction-simple">
  <div class="fraction-top" :style="this.needBottomLine ? ' border-bottom: 2px solid #263238' : ''">
    <slot>

    </slot>
  </div>
  <div class="fraction-bottom">
    <slot name="bottom">

    </slot>
  </div>
</div>
</template>

<script>
export default {
  name: "fomuls-fraction-simple",
  props: {
    needBottomLine: {
      type: Boolean,
      default: true
    },
  },
}
</script>

<style scoped>

</style>